import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const EntityViewModal = ({ isOpen, onClose, entity, entityType, language, onEdit, onDelete }) => {
  if (!isOpen || !entity) return null;

  const labels = {
    workshopTitle: { en: 'Workshop Details', ar: 'تفاصيل الورشة' },
    agencyTitle: { en: 'Agency Details', ar: 'تفاصيل الوكالة' },
    name: { en: 'Name', ar: 'الاسم' },
    images: { en: 'Images', ar: 'الصور' },
    location: { en: 'Location', ar: 'الموقع' },
    coordinates: { en: 'GPS Coordinates', ar: 'إحداثيات GPS' },
    serviceTypes: { en: 'Service Types', ar: 'أنواع الخدمات' },
    edit: { en: 'Edit', ar: 'تعديل' },
    delete: { en: 'Delete', ar: 'حذف' },
    close: { en: 'Close', ar: 'إغلاق' }
  };

  const title = entityType === 'workshops' ? labels?.workshopTitle?.[language] : labels?.agencyTitle?.[language];

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.name?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">{entity?.name}</p>
          </div>

          {entity?.images?.length > 0 && (
            <div>
              <label className="text-sm font-medium text-text-secondary mb-2 block">{labels?.images?.[language]}</label>
              <div className="grid grid-cols-3 gap-3">
                {entity?.images?.map((img, index) => (
                  <Image
                    key={index}
                    src={img}
                    alt={`${entity?.name} ${entityType} image ${index + 1}`}
                    className="w-full h-24 object-cover rounded-lg border border-border"
                  />
                ))}
              </div>
            </div>
          )}

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.location?.[language]}</label>
            <div className="mt-1 flex items-start gap-2">
              <Icon name="MapPin" size={16} className="text-primary mt-1" />
              <p className="text-base font-medium text-foreground">{entity?.location?.address}</p>
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary">{labels?.coordinates?.[language]}</label>
            <p className="text-base font-medium text-foreground mt-1">
              {entity?.location?.lat}, {entity?.location?.lng}
            </p>
          </div>

          <div>
            <label className="text-sm font-medium text-text-secondary mb-2 block">{labels?.serviceTypes?.[language]}</label>
            <div className="flex flex-wrap gap-2">
              {entity?.serviceTypes?.map((service, index) => (
                <span key={index} className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-primary/10 text-primary">
                  {service}
                </span>
              ))}
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              variant="outline"
              fullWidth
              onClick={onEdit}
              iconName="Edit2"
            >
              {labels?.edit?.[language]}
            </Button>
            <Button
              variant="destructive"
              fullWidth
              onClick={onDelete}
              iconName="Trash2"
            >
              {labels?.delete?.[language]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntityViewModal;